import * as React from "react"
import styled from "styled-components"
import { AudioMeter, getUserAudioStream } from "./utils"

export const VolumeMeter: React.FC<{ inputDeviceId: string | undefined, icon?: React.ReactNode, pids?: number }> = (props) => {
    const [audioVol, setAudioVol] = React.useState<number>(0)
    const wrapElem = React.useRef<HTMLDivElement>(null)
    const microphoneStream = React.useRef<MediaStream>()
    const audioCtx: AudioContext = React.useMemo(() => new (window['AudioContext'] || window['webkitAudioContext'])(), []);
    const audioMeter = new AudioMeter(audioCtx)
    let audioMeterRefreshInterval: any // used as a ref for the interval to later cleanup

    // Mic volume meter
    React.useEffect(() => {
        getUserAudioStream(props.inputDeviceId).then(mic => {
            microphoneStream.current = mic // keep a ref of the stream to stop tracks in the cleanup
            audioMeter.connectToSource(mic)
            audioMeterRefreshInterval = setInterval(() => {
                // audioMeter refresh is controlled using interval to allow for fine tuning
                setAudioVol(audioMeter.getLevel())
            }, 10)
        }).catch(err => { })
        return () => {
            clearInterval(audioMeterRefreshInterval)
            audioMeter.disconnectFromSource()
            microphoneStream.current?.getTracks().map(track => track.stop())
        }
    }, [props.inputDeviceId])

    React.useEffect(() => {
        if (wrapElem && wrapElem.current) {
            const allPids = wrapElem.current.children
            const toColour = Math.round(audioVol / allPids.length)
            const active = Array.from(allPids).slice(0, toColour)
            Array.from(allPids).map(child => child.classList.remove("active"))
            active.map((child) => child.classList.add("active"))
        }
    }, [audioVol])

    return <StyledWrapper>
        {props.icon}
        <StyledPidWrapper ref={wrapElem}>
            {Array.from(new Array(props.pids || 10)).map((_, idx) => {
                return <StyledPid key={idx} />
            })}
        </StyledPidWrapper>
    </StyledWrapper>
}

const StyledWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: ${props => props.theme.spacing(1)} 0;
    >svg{
        color: ${props => props.theme.palette.text.secondary};
    }
`
const StyledPidWrapper = styled.div`
    width: 100% ;
    display: flex ;
`
const StyledPid = styled.div`
    width: 10%;
    height:10px;
    margin: 5px;
    border-radius: 100px;
    background-color: ${props => props.theme.palette.text.secondary};
    &.active{
        background-color: ${props => props.theme.palette.primary.main};
    }
`
